import { document } from "managers/Dom";

export const CookieKeys = {
    GDPR_COOKIE: "accept-cookie"
};

const getDomain = function() {
    if (process.env.GATSBY_APP_ENV === "production") {
        return "; domain=.igenius.ai";
    }
    if (process.env.GATSBY_APP_ENV === "stage") {
        return "; domain=.stage.igenius.ai";
    }
    return "; domain=localhost";
};

const cookie = (() => {
    function get(key) {
        const nameEQ = `${key}=`;
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function set(key, value, days = 1, hours = 24, min = 60) {
        let expires = "";

        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * hours * min * 60 * 1000);
            expires = `; expires=${date.toGMTString()}`;
        }

        document.cookie = `${key}=${value}${expires}${getDomain()}; path=/`;
    }

    function remove(key) {
        set(key, "", -1);
    }

    return {
        get,
        set,
        remove
    };
})();

export default cookie;



// WEBPACK FOOTER //
// ./src/managers/CookieManager.js